export const TXTCLI_PO_Box_addresses_are_not_permi_ELL = {
  "id": "TXTCLI_PO_Box_addresses_are_not_permi_ELL",
  "defaultMessage": "PO Box addresses are not permitted. Please enter the residential address where you live."
} as const;